import { restrictions as config } from '@config';

const DesignFacade = require('../../../facade/design/design');
const EditorFacade = require('../../../facade/editor/editor');
const RestrictionsFacade = require('../../../facade/restrictions/restrictions');
const RestrictionsFactory = require('../../../factory/restrictions');
const { sortByProperty } = require('../../../utils/sort');

const template = require('./element-restrictions.hbs');

const RestrictionViews = {
  logo: require('./element/logo-type'),
  icon: require('./element/icon-type'),
  text: require('./element/text-type'),
  image: require('./element/image-type'),
  vector: require('./element/vector-type'),
  video: require('./element/video-type'),
  table: require('./element/table-type'),
  qrcode: require('./element/qrcode-type'),
  background: require('./element/background-type')
};

module.exports = Backbone.mixin(Backbone.View.extend({
  events: {
    'click icon.remove': 'removeRestrictionEvent',
    'click icon.show-restriction': 'showRestrictionEvent',
    'click icon.change-name': 'changeNameEvent'
  },

  removeRestrictionEvent: function (event) {
    INKIVE.Modal.alertMessage('Sure you want to remove element restrictions?', {
      width: 450,
      callback: [
        _.bind(function () {
          RestrictionsFactory.setGlobalElementRestriction(
            $(event.currentTarget).closest('li').data('element')
          );

          this.refresh();
        }, this), $.noop
      ]
    });
  },

  showRestrictionEvent: function (event) {
    const id = $(event.currentTarget).closest('li').data('element');
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const $elem = id === 'background'
      ? $('#svgcontent').children('g.background').children(':not(title)').last()
      : $('#' + id);

    canvas.setMode('select');
    canvas.selectOnly([$elem[0]], true);
  },

  changeNameEvent: function (event) {
    const PromptModal = require('../../../modal/prompt');
    const element = event.currentTarget.closest('li');
    const id = element.getAttribute('data-element');
    const name = element.querySelector('.name').innerText;

    const prompt = new PromptModal({
      label: 'New name',
      defaultValue: name
    });

    const modal = INKIVE.Modal.modalWindow(prompt.getFormHtml(), {
      width: 400,
      headerIcon: 'fa fa-edit',
      headerTitle: INKIVE.TranslateHelper.translate('tool.restrictions.change_restriction_name'),
      buttons: [{
        title: 'Ok',
        onClick: async () => {
          modal.close();
          const name = prompt.getValue();

          element.querySelector('.name').innerHTML = name;

          await RestrictionsFactory.setGlobalRestrictionName(
            id,
            name
          );

          const canvas = INKIVE.Tool.getInstance().editor.canvas;
          canvas.clearSelection();

          this.refresh();
        }
      }]
    });
  },

  initialize: function () {
    _.bindAll(this, 'render', 'refresh', 'setSelection');
    EditorFacade.on('select', this.setSelection);
    this.refresh();
  },

  refresh: function () {
    const deferred = $.Deferred();

    RestrictionsFactory.getElementPermissions().then(_.bind(function (permissions) {
      this.render(permissions);
      deferred.resolve();
    }, this));

    return deferred.promise();
  },

  setSelection: function (elements) {
    const toolPanel = document.querySelector('#tool-panel');
    if (toolPanel && toolPanel.classList.contains('collapsed')) return;

    const element = _(elements).first();
    const type = element && RestrictionsFacade.getType(element.type);
    $('#margin-box, #vertical-line, #horizontal-line').remove();
    this.$el.find('input:focus').blur();

    element
      ? this._createDummyRestrictionTab(element, type)
      : this.dummyRestriction = false;

    const $view = $('<div class="group content"></div>');

    this.currentRestrictionsView && this.currentRestrictionsView.remove();

    if (elements.length < 2 && element && RestrictionViews[type]) {
      this.$el.append($view);
      this.currentRestrictionsView = new RestrictionViews[type]({
        el: $view,
        selection: element
      });

      this.currentRestrictionsView.on('update', _.bind(this.trigger, this, 'update'));
      let hideDummy = false;
      const itemList = this.el.querySelectorAll('.restrictions-list li');

      for (const item of itemList) {
        if (item.parentNode.classList.contains('dummy')) continue;

        if (element.id === item.getAttribute('data-element')) {
          item.classList.remove('hidden');
          item.querySelector('div.actions icon.show-restriction')?.classList.add('hidden');
          hideDummy = true;
        } else {
          item.classList.add('hidden');
        }
      }

      hideDummy && this.el.querySelector('.dummy').classList.add('hidden');
      this.el.querySelector('div .no-restriction')?.classList.add('hidden');
      this.trigger('update');
      return;
    }

    this.refresh();
  },

  _createDummyRestrictionTab: function (element, type) {
    const idParts = element.id.split('_');
    let name = element.type === 'icon' ? 'element' : element.type;
    idParts.length > 1 && (name += ' ' + idParts[1]);
    this.dummyRestriction = { name, element: element.id, icon: config.icons[type] };
    this.refresh();
  },

  render: function (permissions) {
    const restriction = this.getSingleElementPermissions(permissions);

    this.$el.html(template({
      has_restrictions: restriction.length > 0,
      restrictions: restriction,
      dummyRestriction: this.dummyRestriction
    }));

    INKIVE.Helpers.initTooltips($(this.el.querySelector('div.group.no-top-margin')));

    this.trigger('update');
  },

  getSingleElementPermissions: function (permissions) {
    const result = [];
    let name;

    const partial = permissions.map(permission => {
      const data = permission.page_number === INKIVE.Tool._current_page_number && DesignFacade.get(permission.element_id);

      if (data) {
        if (permission.name) {
          name = permission.name;
        } else {
          const idParts = permission.element_id.split('_');
          name = data.type;

          if (idParts.length > 1) {
            name += ' ' + idParts[1];
          }
        }
      }

      return data ? { name, element: permission.element_id, icon: config.icons[data.type], can_delete: permission.element_id !== 'background' } : {};
    });

    partial.forEach(permission => {
      const isAlreadyThere = result.find(item => item.element === permission.element);
      const elementExists = permission.element === 'background' || document.querySelector(`#svgcontent .main > #${permission.element}`);

      if (!isAlreadyThere && elementExists) {
        result.push(permission);
      }
    });

    return result.sort(sortByProperty('name'));
  }
}), Backbone.Events);
